import React, { useState } from "react";
import styles from "../../styles/proposal/projectDetail.module.css";
import ReactPlayer from "react-player";
import { Grid } from "@mui/material";

const VideoPlayer = (props: any) => {
  const [error, setError] = useState(false);

  function onError(event: any) {
    setError(true);
  }

  return (
    <>
      {!error && (
        <Grid item xs={12} lg={6} key={props.url} direction="row">
          <div className={styles.playerWrapper}>
            <ReactPlayer
              url={props.url}
              onError={onError}
              className={styles.reactPlayer}
              width="100%"
              height="100%"
            />
          </div>
        </Grid>
      )}
      {/* {error && <p>Unable to load video.</p>} */}
    </>
  );
};

export default VideoPlayer;
